module.exports = __webpack_public_path__ + "img/icon-star.9f8ab2dc.svg";